import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { AnalyticsProvider } from './contexts/AnalyticsContext'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Toaster } from "react-hot-toast";

// Components
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import ScrollToTop from './components/common/ScrollToTop'
import LoadingSpinner from './components/common/LoadingSpinner'

// Pages
import HomePage from './pages/HomePage'
import ProductsPage from './pages/ProductsPage'
import ProductDetailPage from './pages/ProductDetailPage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import DashboardPage from './pages/DashboardPage'
import PublicProfilePage from './pages/PublicProfilePage'
import NotFoundPage from './pages/NotFoundPage'
import AIReviewGeneratorPage from './pages/AIReviewGeneratorPage'

// App Section Pages
import AppRegisterPage from './pages/app/RegisterPage'
import AppLoginPage from './pages/app/LoginPage'
import AppDashboardPage from './pages/app/DashboardPage'
// Admin imports
import AdminLoginPage from './pages/admin/AdminLoginPage'
import AdminDashboardPage from './pages/admin/AdminDashboardPage'
import VisitSearchPage from './pages/visit-view/VisitSearchPage'
import VisitProfileView from './pages/visit-view/VisitProfileView'

// Partner Pages
import PartnerRegister from './pages/PartnerRegister'
import PartnerLogin from './pages/PartnerLogin'
import PartnerDashboard from './pages/PartnerDashboard'

// Register GSAP plugins globally
gsap.registerPlugin(ScrollTrigger)

function App() {
  // Removed global ScrollTrigger setup to prevent conflicts with individual sections

  return (
    <ThemeProvider>
      <AuthProvider>
        <AnalyticsProvider>
            <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 3000,
        }}
      />
          <div className="App min-h-screen bg-white dark:bg-black transition-colors duration-300">
            <Helmet>
              <title>FiindIt- Digital Profile Platform | Share Instantly. Connect Effortlessly.</title>
              <meta name="description" content="FiindIt is a revolutionary digital profile platform for NFC-based smart sharing and lead management. Transform your networking experience with instant sharing and effortless connections." />
              <meta name="keywords" content="NFC, digital business card, lead management, smart sharing, professional networking, FiindIt" />
              <link rel="canonical" href="https://www.fiindit.in" />
            </Helmet>

            <Routes>
              {/* App Section Routes */}
              <Route path="/app/register" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <AppRegisterPage />
                  </main>
                  <Footer />
                </>
              } />
              <Route path="/app/login" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <AppLoginPage />
                  </main>
                  <Footer />
                </>
              } />
              <Route path="/app/*" element={<AppDashboardPage />} />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/*" element={<AdminDashboardPage />} />

              {/* Main Website Routes with Layout */}
              <Route path="/" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <HomePage />
                  </main>
                  <Footer />
                  <ScrollToTop />
                </>
              } />
              <Route path="/products" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <ProductsPage />
                  </main>
                  <Footer />
                  <ScrollToTop />
                </>
              } />
              <Route path="/product/:slug" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <ProductDetailPage />
                  </main>
                  <Footer />
                  <ScrollToTop />
                </>
              } />
              <Route path="/about" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <AboutPage />
                  </main>
                  <Footer />
                  <ScrollToTop />
                </>
              } />
              <Route path="/contact" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <ContactPage />
                  </main>
                  <Footer />
                  <ScrollToTop />
                </>
              } />
              <Route path="/dashboard/*" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <DashboardPage />
                  </main>
                  <Footer />
                  <ScrollToTop />
                </>
              } />
              <Route path="/profile/:username" element={<PublicProfilePage />} />
              <Route path="/p/:username" element={<PublicProfilePage />} />
              <Route path="/review/:username" element={<AIReviewGeneratorPage />} />
              
              {/* Visit View Routes */}
              <Route path="/visit" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <VisitSearchPage />
                  </main>
                  <Footer />
                </>
              } />
              <Route path="/visit/p/:username" element={<VisitProfileView />} />

              {/* Partner Routes */}
              <Route path="/partner/register" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <PartnerRegister />
                  </main>
                  <Footer />
                </>
              } />
              <Route path="/partner/login" element={
                <>
                  <Navbar />
                  <main className="flex-1 pt-16">
                    <PartnerLogin />
                  </main>
                  <Footer />
                </>
              } />
              <Route path="/partner/dashboard" element={
                <main className="flex-1">
                  <PartnerDashboard />
                </main>
              } />

              <Route path="*" element={
                <>
                  <Navbar />
                  <main className="flex-1">
                    <NotFoundPage />
                  </main>
                  <Footer />
                  <ScrollToTop />
                </>
              } />
             
            </Routes>
          </div>
        </AnalyticsProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App 